import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Ruler } from 'lucide-react';
export function ProofSection() {
  return <section className="py-24 bg-sage text-white text-center" data-id="element-339">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-340">
        <FadeIn data-id="element-341">
          <Ruler className="w-12 h-12 mx-auto mb-6 text-mint opacity-80" data-id="element-342" />
          <h2 className="text-3xl md:text-5xl font-bold mb-8 text-white leading-tight" data-id="element-343">
            Resultados Reales en Tiempo Récord
          </h2>
          <p className="text-xl md:text-2xl font-light leading-relaxed mb-8 text-mint" data-id="element-344">
            En solo 72 horas, la mayoría de los usuarios reportan una reducción
            de entre{' '}
            <strong className="font-bold text-white" data-id="element-345">
              2 y 5 cm de circunferencia abdominal
            </strong>
            .
          </p>
          <p className="text-lg md:text-xl opacity-90 mb-12 max-w-2xl mx-auto" data-id="element-346">
            No es pérdida de tejido adiposo; es la liberación literal de
            retención de líquidos inflamatorios y gases que tu cuerpo ya no
            necesita cargar.
          </p>
          <Button onClick={() => window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        })} className="bg-white text-sage hover:bg-mint" data-id="element-347" />
        </FadeIn>
      </div>
    </section>;
}